import { restService, RestService } from 'app/api/common';

class CustomerService {
    private static readonly getBasePath = (partnerId: string): string => `/v1/${partnerId}/customers`;

    private readonly restService: RestService;

    public constructor() {
        this.restService = restService;
    }

    public readonly getCustomerInformation = (
        partnerId: string,
        billingAccountId: string,
    ): Promise<OrderTrackerBackend.CustomerInformation> =>
        this.restService.get<OrderTrackerBackend.CustomerInformation>(
            `${CustomerService.getBasePath(partnerId)}/${billingAccountId}`,
        );
}

const customerService = new CustomerService();

export { customerService, CustomerService };
